'use client';

import {
  ArrowDown01Icon,
  Clock01Icon,
  SecurityCheckIcon,
  ShieldBanIcon,
} from '@terra/ui-icons';
import { useTranslations } from 'next-intl';
import { Button } from '../../../components/button';
import { Menu } from '../../../components/menu';
import type { ScopeMenuProps } from './scope-types';

export function ScopeMenu({ isDisabled, onScopeChange }: ScopeMenuProps) {
  const t = useTranslations('designSystem.networkSettings.externalScope');

  return (
    <Menu.Root positioning={{ strategy: 'fixed' }}>
      <Menu.Trigger asChild>
        <Button
          size="xs"
          variant="ghost"
          disabled={isDisabled}
          px={1.5}
          aria-label={t('scopeColumn')}
        >
          <ArrowDown01Icon size={13} />
        </Button>
      </Menu.Trigger>
      <Menu.Positioner>
        <Menu.Content minW="160px" py={1}>
          <Menu.Item
            value="in-scope"
            onClick={() => onScopeChange('IN_SCOPE')}
            px={3}
            py={2}
            gap={2}
          >
            <SecurityCheckIcon size={14} />
            {t('scopeInScope')}
          </Menu.Item>
          <Menu.Item
            value="out-of-scope"
            onClick={() => onScopeChange('OUT_OF_SCOPE')}
            px={3}
            py={2}
            gap={2}
          >
            <ShieldBanIcon size={14} />
            {t('scopeOutOfScope')}
          </Menu.Item>
          <Menu.Item
            value="pending"
            onClick={() => onScopeChange('PENDING')}
            px={3}
            py={2}
            gap={2}
          >
            <Clock01Icon size={14} />
            {t('scopePending')}
          </Menu.Item>
        </Menu.Content>
      </Menu.Positioner>
    </Menu.Root>
  );
}
